import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox } from '@material-ui/core';
import { dotNotationExtractor, isFunction } from 'utils/functions';
import { formatter } from 'constantes/constants';
import Check from 'components/Check';
import Chip, { ChipColors } from 'components/Chip';

function Row({
  columns, data = {}, checked = false, setCheck, selectableCondition,
}) {
  
  const disableCheckbox = !selectableCondition?.(data);

  return (
    <TableRow>
      <TableCell padding="checkbox">
        <Checkbox
          checked={checked}
          onChange={() => setCheck(data)}
          disabled={disableCheckbox}
        />
      </TableCell>
      {columns.map((col, index) => {
        let cellContent = col.component || dotNotationExtractor(data, col.name);
        cellContent = isFunction(cellContent) ? cellContent(data) : cellContent;
        cellContent = col.type === 'number' ? formatter.format(cellContent ?? 0) : cellContent;
        switch (col.type) {
        case 'number': cellContent = formatter.format(cellContent ?? 0);
          break;
        case 'money': cellContent = `$${formatter.format(Math.trunc(cellContent ?? 0))}`;
          break;
        case 'money_decimal': cellContent = `$${formatter.format(cellContent ?? 0)}`;
          break;
        case 'check': cellContent = <Check activo={cellContent} />;
          break;
        case 'active': cellContent = (
          <Chip
            activo={cellContent}
            label={cellContent ? 'activo' : 'inactivo'}
            color={cellContent ? ChipColors.GREEN : ChipColors.RED}
          />
        );
          break;
        case 'percent': cellContent = `${Number(cellContent).toFixed(2)}%` ?? 0;
          break;
        case 'percentage': cellContent = `${Number(cellContent).toFixed(0)}%` ?? 0;
          break;
        default:
          break;
        }
        return (
          <TableCell key={`Col${String(index)}`} align={col.align || 'left'} style={{ width: col.width ? col.width : '' }}>
            {cellContent}
          </TableCell>
        );
      })}
    </TableRow>
  );
}

Row.defaultProps = {
  selectableCondition: () => true,
};

Row.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  data: PropTypes.oneOfType([PropTypes.object]),
  checked: PropTypes.bool,
  setCheck: PropTypes.func,
  selectableCondition: PropTypes.func,
};

export default Row;
